export function getBooleanValue(value) {
  return value === '1' || value === 'true' || value === 'TRUE' || value === true;
}
